import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { WrapperCommon } from '../../../../common/cell-wrapper/index.tsx';

type Props = {
	children?: string;
};

export const RadioSelectRead = ({ children }: Props) => {
	if (!children) {
		return null;
	}
	return (
		<WrapperCommon>
			<Box xcss={optionWrapperStyles}>
				<Box xcss={optionTextStyles}>{children}</Box>
			</Box>
		</WrapperCommon>
	);
};

const optionWrapperStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	overflow: 'hidden',
	padding: 'space.075',
});

// TODO: replace with Text component from atlaskit when out of beta
const optionTextStyles = xcss({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});
